var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoplug(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b{fill:#c8d1ec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -494)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46,
    height: 46,
    rx: 5,
    transform: "translate(27 494)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.248 491.771)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.74,17.787A12.15,12.15,0,0,0,1.671,32.531a12.216,12.216,0,0,0,4.386,4.361,1.054,1.054,0,0,0,1.058-1.822,10.043,10.043,0,1,1,15.075-8.691,8.359,8.359,0,0,1-1.833,5.646,4.879,4.879,0,0,1-3.595,1.733,3.383,3.383,0,0,1-3.344-2.517,4.657,4.657,0,0,0,3.708-4.553v-3.07a.263.263,0,0,0-.263-.263H15.454V20.48a1.054,1.054,0,0,0-2.107,0v2.874h-2.4V20.48a1.054,1.054,0,0,0-2.107,0v2.874H7.435a.263.263,0,0,0-.263.263v3.07A4.656,4.656,0,0,0,11.264,31.3a5.881,5.881,0,0,0,1.528,2.941,5.5,5.5,0,0,0,3.97,1.621,6.983,6.983,0,0,0,5.172-2.443A10.272,10.272,0,0,0,24.3,26.378,12.07,12.07,0,0,0,20.74,17.787Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoplug);
export default __webpack_public_path__ + "static/media/noplug.2c8affd5dcf0116da249f3fbc10d96c7.svg";
export { ForwardRef as ReactComponent };